/**
 * Encodes a URL while preserving the URL structure
 * @param {string} urlString - The URL to encode
 * @returns {string} - The encoded URL
 */
export const encodePromotionUrl = (urlString) => {
  if (!urlString) return urlString;
  
  try {
    const url = new URL(urlString);
    // Split the pathname into segments and encode each segment individually
    const encodedPathname = url.pathname.split('/')
      .map(segment => segment ? encodeURIComponent(segment) : '')
      .join('/');
    
    // Preserve the original URL structure
    url.pathname = encodedPathname;
    return url.toString();
  } catch (error) {
    // If URL parsing fails, do a simple encode of the entire URL
    return encodeURI(urlString);
  }
};

/**
 * Decodes a URL while preserving the URL structure and handling double-encoded URLs
 * @param {string} urlString - The URL to decode
 * @returns {string} - The decoded URL
 */
export const decodePromotionUrl = (urlString) => {
  if (!urlString) return urlString;
  
  // First handle the %2520 case (double-encoded space)
  let decodedUrl = urlString.replace(/%2520/g, ' ');
  
  try {
    const url = new URL(decodedUrl);
    
    // Split the pathname into segments and decode each segment individually
    const decodedPathname = url.pathname.split('/')
      .map(segment => {
        if (!segment) return '';
        try {
          // First try to decode normally
          return decodeURIComponent(segment);
        } catch (e) {
          // If decoding fails, return the original segment
          return segment;
        }
      })
      .join('/');
    
    // Preserve the original URL structure
    url.pathname = decodedPathname;
    
    // For query parameters, we want to keep them encoded
    return url.toString();
  } catch (error) {
    // If URL parsing fails, try to decode the entire string
    try {
      return decodeURIComponent(decodedUrl);
    } catch (e) {
      return decodedUrl;
    }
  }
}; 